import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: {},
  params: {},
};

export default function cercasVirtuais(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@cercasVirtuais/FIND_DATA':
      case '@cercasVirtuais/UPDATE_DATA':
      case '@cercasVirtuais/DELETE_DATA':
      case '@cercasVirtuais/STORE_DATA':
      case '@cercasVirtuais/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@cercasVirtuais/SUCCESS_REMOVE':
      case '@cercasVirtuais/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@cercasVirtuais/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@cercasVirtuais/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@cercasVirtuais/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      case '@cercasVirtuais/RESET_FIND': {
        draft.find = {};
        break;
      }

      default:
    }
  });
}
